module.exports = __webpack_public_path__ + "img/m3.c6a931e9.jpg";